import axios from "axios";
import {
  FETCH_COMPRAS_REQUEST,
  FETCH_COMPRAS_SUCCESS,
  FETCH_COMPRAS_FAILURE,
} from "./types";
import { PATH } from "../../utils";

const api = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const actionComprasGet = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_COMPRAS_REQUEST });
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const res = await api.get("/compras", { headers: authHeader(), params: cleanParams });
    const items = Array.isArray(res.data) ? res.data : res.data?.items ?? [];
    dispatch({ type: FETCH_COMPRAS_SUCCESS, payload: items });
  } catch (err) {
    const msg = err?.response?.data?.detail || err.message || "Error al cargar compras";
    dispatch({ type: FETCH_COMPRAS_FAILURE, payload: { error: msg } });
  }
};

export const apiComprasInstance = api;
export { authHeader as authHeaderCompras };
